import { FC, useState, useEffect } from 'react';
import { ProButton } from '../antd';
import { ButtonProps } from 'antd/lib/button';

type ILoading = boolean | { delay?: number } | undefined;
/** 异步按钮 */
export interface SyncButtonProps extends ButtonProps {
  /** 异步点击事件 */
  onClick?: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => Promise<any>) | ((event: React.MouseEvent<HTMLElement, MouseEvent>) => any);
}
/** 异步按钮 */
const SyncButton: FC<SyncButtonProps> = props => {
  const { children, loading, onClick, ...restProps } = props;
  const [buttonLoading, setButtonLoading] = useState<ILoading>(loading);
  useEffect(() => {
    if (loading !== undefined) setButtonLoading(loading);
  }, [loading]);
  const handleClick = async (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    if (onClick) {
      setButtonLoading(true);
      await onClick?.(event);
      setButtonLoading(false);
    }
  };
  return (
    <ProButton {...restProps} loading={buttonLoading} onClick={handleClick}>
      {children}
    </ProButton>
  );
};

export default SyncButton;
